/* EVERLA — storefront behaviors (Shopify). Same interactions as the site2 prototype, on native cart/variant/filter APIs. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.documentElement.classList.add('js');

  function money(cents) {
    var fmt = (window.EVERLA && window.EVERLA.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, parts.join('.'));
  }
  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2000);
  }
  function paintCount(n) {
    $$('.cartn').forEach(function (b) { b.textContent = String(n); b.setAttribute('aria-label', n + (n === 1 ? ' item in cart' : ' items in cart')); });
  }
  function cartRequest(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { paintCount(c.item_count); return c; });
  }

  /* background videos: nudge autoplay (Safari / low-power) */
  $$('video[autoplay]').forEach(function (v) {
    v.muted = true;
    if (reduceMotion) { v.removeAttribute('autoplay'); v.pause(); return; }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    document.addEventListener('touchstart', function () { if (v.paused) v.play().catch(function () {}); }, { once: true, passive: true });
  });

  /* Event Guide video: load near the viewport, sticky user pause */
  $$('[data-lazy-video]').forEach(function (v) {
    var tile = v.closest('.guide .big'); var toggle = tile ? $('.guide-video-toggle', tile) : null; var source = $('source[data-src]', v);
    if (!tile || !toggle || !source) return;
    var icon = $('span', toggle); var userPaused = false;
    function paint(playing) { toggle.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' Event Guide video'); toggle.setAttribute('aria-pressed', playing ? 'true' : 'false'); if (icon) icon.textContent = playing ? '❚❚' : '▶'; }
    function load() { if (source.getAttribute('src')) return true; var u = source.getAttribute('data-src'); if (!u) return false; source.setAttribute('src', u); v.load(); return true; }
    function play() { if (!load()) return; var p = v.play(); if (p && p.catch) p.catch(function () { paint(false); }); }
    v.addEventListener('play', function () { paint(true); }); v.addEventListener('pause', function () { paint(false); });
    toggle.addEventListener('click', function () { if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); } });
    paint(false);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!reduceMotion && !userPaused) play(); } else if (!v.paused) v.pause(); }); }, { rootMargin: '240px 0px', threshold: 0.01 }).observe(v);
    }
  });

  /* product card videos: play on hover only */
  $$('.card-vid').forEach(function (v) {
    var card = v.closest('.card'); if (!card) return;
    card.addEventListener('mouseenter', function () { if (reduceMotion) return; if (!v.getAttribute('data-loaded')) { v.setAttribute('data-loaded', '1'); v.load(); } var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    card.addEventListener('mouseleave', function () { v.pause(); });
  });

  /* mobile drawer */
  var burger = $('.burger');
  if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); burger.setAttribute('aria-expanded', document.body.classList.contains('menu-open') ? 'true' : 'false'); });
  $$('.drawer .close').forEach(function (b) { b.addEventListener('click', function () { document.body.classList.remove('menu-open'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { document.body.classList.remove('menu-open'); $$('.lightbox.on').forEach(function (l) { l.classList.remove('on'); }); } });

  /* card quick add (native cart) */
  $$('.card-cart[data-variant-id]').forEach(function (row) {
    var id = row.getAttribute('data-variant-id'); var title = row.getAttribute('data-cart-title') || 'item';
    var add = $('[data-card-add]', row), dec = $('[data-card-dec]', row), inc = $('[data-card-inc]', row), input = $('.card-qty input', row), stepper = $('.card-qty', row);
    var qty = parseInt(row.getAttribute('data-in-cart') || '0', 10) || 0;
    function paintRow() { var has = qty > 0; row.classList.toggle('has-quantity', has); if (add) { add.textContent = has ? 'Added' : add.getAttribute('data-label') || 'Add to Cart'; add.disabled = has; } if (stepper) stepper.hidden = !has; if (input) input.value = String(has ? qty : 1); }
    function set(n) {
      n = Math.max(0, n | 0); row.classList.add('busy');
      var req = qty === 0 ? cartRequest('cart/add.js', { items: [{ id: id, quantity: n }] }) : cartRequest('cart/change.js', { id: id, quantity: n });
      return req.then(function () { qty = n; paintRow(); return refreshCount(); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not update the cart.'); paintRow(); })
        .then(function () { row.classList.remove('busy'); });
    }
    paintRow();
    if (add) add.addEventListener('click', function (e) { e.preventDefault(); if (!add.disabled) set(1).then(function () { toast('Added to cart — ' + title); }); });
    if (dec) dec.addEventListener('click', function (e) { e.preventDefault(); set(qty - 1); });
    if (inc) inc.addEventListener('click', function (e) { e.preventDefault(); set(qty + 1); });
    if (input) input.addEventListener('change', function () { var n = parseInt(input.value, 10); if (isNaN(n) || n < 0) { input.value = qty; return; } set(n); });
  });

  /* qty steppers (PDP + cart) */
  $$('.qty').forEach(function (q) {
    var i = $('input', q); if (!i) return;
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () { var v = parseInt(i.value, 10) || 1; v += b.getAttribute('data-d') === '-' ? -1 : 1; if (v < (q.hasAttribute('data-zero') ? 0 : 1)) v = q.hasAttribute('data-zero') ? 0 : 1; i.value = v; i.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  });

  /* PDP: variant picker, gallery swap, add to cart */
  var pdp = $('[data-product-form]');
  if (pdp) {
    var variants = []; try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) {}
    var form = $('form[action*="/cart/add"]', pdp), idInput = form ? $('input[name="id"]', form) : null, atc = $('.atc', pdp);
    var priceEl = $('[data-price]', pdp), stockEl = $('[data-stock]', pdp), studio = $('[data-gallery-slot="studio"]');
    var opts = $$('.opt', pdp);
    function selected() { return opts.map(function (o) { var on = $('.v.on', o); return on ? on.getAttribute('data-option-value') : null; }); }
    function find(vals) { return variants.filter(function (v) { return v.options.every(function (x, i) { return x === vals[i]; }); })[0]; }
    function paintOptions() {
      var vals = selected();
      opts.forEach(function (o, oi) {
        $$('.v', o).forEach(function (b) {
          var probe = vals.slice(); probe[oi] = b.getAttribute('data-option-value');
          var v = find(probe); b.classList.toggle('off', !v || !v.available);
        });
        var lb = $('.lb span', o); if (lb) lb.textContent = vals[oi] || '';
      });
    }
    function apply(v) {
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><span class="off">Save ' + Math.round(100 * (1 - v.price / v.compare_at_price)) + '%</span>' : '');
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label') || 'Add to Cart') : 'Sold out'; }
      if (stockEl) { stockEl.classList.toggle('out', !v.available); stockEl.innerHTML = '<i></i>' + (v.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out')); }
      if (studio && v.featured_image && v.featured_image.src) {
        var im = $('img', studio); var src = v.featured_image.src;
        if (im) { im.removeAttribute('srcset'); im.src = src; } studio.setAttribute('href', src);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    opts.forEach(function (o) {
      $$('.v', o).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.v', o).forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          paintOptions(); apply(find(selected()));
        });
      });
    });
    if (variants.length) { paintOptions(); }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); if (!idInput || atc.disabled) return;
      var q = parseInt(($('.qty input', pdp) || {}).value, 10) || 1; atc.classList.add('busy');
      cartRequest('cart/add.js', { items: [{ id: idInput.value, quantity: q }] })
        .then(function () { refreshCount(); toast('Added to cart — ' + (pdp.getAttribute('data-title') || 'item')); })
        .catch(function (err) { toast((err && err.description) || 'Could not add to cart.'); })
        .then(function () { atc.classList.remove('busy'); });
    });
    /* add-on */
    $$('[data-addon-id]', pdp).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); b.classList.add('busy'); cartRequest('cart/add.js', { items: [{ id: b.getAttribute('data-addon-id'), quantity: 1 }] }).then(function () { refreshCount(); toast('Added to cart — ' + b.getAttribute('data-addon-title')); }).catch(function (err) { toast((err && err.description) || 'Could not add to cart.'); }).then(function () { b.classList.remove('busy'); }); });
    });
    /* lightbox */
    var lb = $('.lightbox');
    $$('.gal-item.zoom').forEach(function (a) {
      a.addEventListener('click', function (e) { if (!lb) return; e.preventDefault(); $('img', lb).src = a.getAttribute('href'); lb.classList.add('on'); });
    });
    if (lb) { lb.addEventListener('click', function (e) { if (e.target === lb || e.target.tagName === 'BUTTON') lb.classList.remove('on'); }); }
  }

  /* homepage tabs */
  var tabs = $$('.tabs button');
  if (tabs.length) tabs.forEach(function (t) {
    t.addEventListener('click', function () { tabs.forEach(function (x) { x.classList.remove('on'); }); t.classList.add('on'); var k = t.getAttribute('data-tab'); $$('[data-pane]').forEach(function (p) { p.style.display = p.getAttribute('data-pane') === k ? '' : 'none'; }); });
  });

  /* collection: sort, sub-collection tiles (client-side, like the prototype), facet form */
  var grid = $('#pgrid');
  if (grid) {
    var sel = $('.sort select');
    if (sel) sel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); });
    var qs = new URLSearchParams(location.search); var sub = qs.get('sub') || '';
    function applySub() {
      var cards = $$('.card', grid), shown = 0;
      cards.forEach(function (c) { var ok = !sub || c.getAttribute('data-sub') === sub; c.style.display = ok ? '' : 'none'; if (ok) shown++; });
      var cnt = $('.count'); if (cnt && sub) cnt.textContent = shown + ' product' + (shown === 1 ? '' : 's');
      var em = $('.empty'); if (em) em.style.display = shown ? 'none' : '';
      $$('.subs a').forEach(function (a) { a.classList.toggle('on', (a.getAttribute('data-sub') || '') === sub); });
    }
    $$('.subs a[data-sub]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var s = a.getAttribute('data-sub') || ''; sub = sub === s ? '' : s; var u = new URL(location.href); if (sub) u.searchParams.set('sub', sub); else u.searchParams.delete('sub'); history.replaceState(null, '', u); applySub(); });
    });
    applySub();
    var facets = $('form.facets');
    if (facets) {
      facets.addEventListener('change', function (e) { if (e.target.type === 'checkbox') facets.requestSubmit ? facets.requestSubmit() : facets.submit(); });
      document.addEventListener('click', function (e) { $$('details[open]', facets).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); }); });
    }
  }

  /* category carousel arrows */
  $$('.catrow').forEach(function (row) {
    var tr = $('.track', row);
    $$('.arr', row).forEach(function (a) { a.addEventListener('click', function () { tr.scrollBy({ left: (a.classList.contains('l') ? -1 : 1) * tr.clientWidth * 0.8, behavior: 'smooth' }); }); });
  });

  /* cart page: live quantity updates */
  $$('[data-cart-line]').forEach(function (line) {
    var key = line.getAttribute('data-cart-line'); var input = $('.qty input', line);
    function change(n) { line.classList.add('busy'); cartRequest('cart/change.js', { id: key, quantity: n }).then(function () { location.reload(); }).catch(function (err) { toast((err && err.description) || 'Could not update.'); line.classList.remove('busy'); }); }
    if (input) input.addEventListener('change', function () { var n = parseInt(input.value, 10); if (isNaN(n) || n < 0) return; change(n); });
    var rm = $('.rm', line); if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); change(0); });
  });

  /* header search: expand */
  var sbtn = $('[data-search-toggle]'), sbox = $('.hdr .searchbox');
  if (sbtn && sbox) sbtn.addEventListener('click', function (e) { if (window.innerWidth <= 820) return; e.preventDefault(); sbox.style.display = 'inline-flex'; $('input', sbox).focus(); sbtn.style.display = 'none'; });
})();
